var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExternalLinkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 0.5C1.25578 0.5 0.5 1.25578 0.5 2.16667V13.8333C0.5 14.7442 1.25578 15.5 2.16667 15.5H13.8333C14.7442 15.5 15.5 14.7442 15.5 13.8333V8H13.8333V13.8333H2.16667V2.16667H8V0.5H2.16667ZM9.66667 0.5V2.16667H12.6549L4.91081 9.91081L6.08919 11.0892L13.8333 3.34505V6.33333H15.5V0.5H9.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExternalLinkBlack);
export default __webpack_public_path__ + "static/media/ic_external_link_black.647df60cee81183383cd0fea856705f8.svg";
export { ForwardRef as ReactComponent };